'use client';

import { useEffect, useRef } from 'react';

import {
    ACTIVATE_OFFER_POST_LOGIN_ACTION,
    discardPostLoginIntent,
    doPostLoginAction,
    isAuth0CallbackPath,
    OPEN_OFFER_DETAILS_POST_LOGIN_ACTION,
} from '@libs/common-next';

import { useOfferCardActions } from '../OfferCard/use-offer-card-actions';
import type { OfferPageSection } from '../OfferCard/useOfferDrawerStore';

type Props = { discardOnly?: boolean };

function ResumeOfferIntent() {
    const { handleOfferSignInSuccess } = useOfferCardActions();
    const attempted = useRef(false);

    useEffect(() => {
        if (attempted.current || isAuth0CallbackPath(window.location.pathname)) {
            return;
        }

        attempted.current = true;
        doPostLoginAction(OPEN_OFFER_DETAILS_POST_LOGIN_ACTION, params =>
            handleOfferSignInSuccess(params.offerId, false, params.gtmSection as OfferPageSection)
        );
        doPostLoginAction(ACTIVATE_OFFER_POST_LOGIN_ACTION, params =>
            handleOfferSignInSuccess(params.offerId, true, params.gtmSection as OfferPageSection)
        );
    }, [handleOfferSignInSuccess]);

    return null;
}

export function PostLoginOfferIntentHandler({ discardOnly = false }: Props) {
    useEffect(() => {
        if (discardOnly) {
            discardPostLoginIntent();
        }
    }, [discardOnly]);

    return discardOnly ? null : <ResumeOfferIntent />;
}
